module.exports = __webpack_public_path__ + "images/ca54f477cc02aa418eb9aa374ce70d35.svg";